/*
 * Voyado Product Row controller (generic, no-productKey algorithms).
 * ------------------------------------------------------------------
 * Thin per-surface controller for the generic sections/voyado-product-row.liquid
 * section: lifecycle + one VoyadoCarousel.attach call whose opts.fetch runs the
 * merchant-chosen no-productKey algorithm (NEWEST_PRODUCTS / PERSONAL) through the
 * cart-page or landing-page query. The route + algorithm are allow-listed in Liquid
 * and read from data-voyado-query / data-voyado-algorithm — never free text. The
 * scroll engine, slide wrapper, cards-rendered dispatch and controls mirror all live
 * in the shared assets/voyado-carousel.js (window.VoyadoCarousel).
 *
 * Loaded section-scoped + URL-deduped (type=module).
 */
;(function () {
  'use strict';

  var SELECTOR = '[data-voyado-product-row]';
  var attached = new WeakSet();

  function attach(section) {
    if (attached.has(section) || !window.VoyadoCarousel) return;
    attached.add(section);

    var query = section.getAttribute('data-voyado-query') || 'landingPage';
    var algorithm = section.getAttribute('data-voyado-algorithm') || '';
    var rawLimit = parseInt(section.getAttribute('data-recommendation-limit'), 10);
    var limit = rawLimit > 0 ? Math.min(24, rawLimit) : 12;

    window.VoyadoCarousel.attach(section, {
      trigger: 'intersection',
      fetch: function () {
        var client = window.VoyadoClient;
        if (!algorithm || !client || typeof client[query] !== 'function') {
          return Promise.reject(new Error('voyado-product-row: no algorithm/query'));
        }
        // landing-page requires a pageReference (cart-page does not); the
        // recommendationList algorithm drives the products, the ref is just context.
        var params = { presentCustom: 'swatch_image_url|product_badges|colour_name' };
        if (query === 'landingPage') { params.pageReference = window.location.pathname || '/'; }
        return client[query](
          params,
          { recommendationLists: [{ id: 'product-row', algorithm: algorithm, limit: limit }] }
        ).then(function (res) {
          var list = res && res.recommendationLists && res.recommendationLists[0];
          return ((list && list.productGroups) || [])
            .map(function (g) { return (g && g.products) || []; })
            .filter(function (ps) { return ps.length; })
            .slice(0, limit);
        });
      }
    });
  }

  function initAll(root) {
    var r = root || document;
    var nodes = r.querySelectorAll ? r.querySelectorAll(SELECTOR) : [];
    nodes.forEach(attach);
  }

  function teardown(root) {
    if (!root || !root.querySelectorAll || !window.VoyadoCarousel) return;
    root.querySelectorAll(SELECTOR).forEach(function (section) {
      window.VoyadoCarousel.detach(section);
      attached.delete(section);
    });
  }

  if (document.readyState === 'complete') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
